import { Component, Input, OnInit } from '@angular/core';
import { MbAlert, MbAlertDescription } from '@am/moebius';

@Component({
  selector: 'am-few-offer',
  standalone: true,
  styleUrls: ['./few-offer.component.scss'],
  templateUrl: './few-offer.component.html',
  imports: [MbAlert, MbAlertDescription],
})
export class FewOfferComponent implements OnInit {
  @Input()
  public occupancy: number;

  public openAlert = true;

  constructor() {}

  public ngOnInit(): void {}

  public togglesCloseAlert() {
    this.openAlert = false;
  }
}
